import type { SVGProps } from 'react';

export const SpacesIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg width={28} viewBox="1 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M15.695 0a4 4 0 0 0-4 4v20a4 4 0 0 0 4 4h9a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-15 8h8V4h-8zm0 16h8v-4h-8zm0-12h8v4h-8z"
			fill="currentColor"
		/>
	</svg>
);
